import cogoToast from "cogo-toast-react-17-fix";
import dayjs from 'dayjs';
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import API from '../../../ApiConfig'
import { DOCUMENT_PREVIEW, REVOKE_DOCUMENT } from "../../../Utils/constant";
import { _ToNormal } from '../../../Utils/helper'
import ShimmerLoader from "../../../components/ShimmerLoader";
import ReactPortalModal from '../../../components/ReactPortalModal'
import BtnLoader from '../../../components/BtnLoader'
import Loader from "../../../components/Loader";

import Icon from "react-icons-kit";
import { androidOpen } from 'react-icons-kit/ionicons/androidOpen'
import { useSelector } from "react-redux";
import { download } from 'react-icons-kit/fa/download'

const Records = ({ IssuerData, refreshList, loading, sortBy,onSortChange, activeTab }) => {

  const [Popup, setPopup] = useState(false);
  const [preview, setPreview] = useState(null)
  const [Loading, setloading] = useState(false);
  const [pdfLoading, setPDFloading] = useState(null)

  const [loadingText, setLoadingText] = useState('Genrating PDF... Please Wait')
  const User=useSelector(state=>state.User)
  const revokeConfirm = (item) => {
    const { hide } = cogoToast.info(<div>
      <button className='btn btn-primary fnt-12' onClick={() => revokeDocument(item)}>Yes</button>
      <button className='btn btn-secondary ml-4 fnt-12'>No</button>
    </div>, {
      hideAfter: 10,
      heading: 'Please confirm to revoke',
      onClick: () => { hide() }
    })
  }
  function revokeDocument(item) {
    API.get(REVOKE_DOCUMENT + item.doc_field.details.issued_uuid)
      .then(res => {
        if (res.data.status === 200) {
          cogoToast.success(res.data.message)
          refreshList()

        }
      })
      .catch(err => {
        cogoToast.error('Something went wrong while performing action!')
      })
  }
  const updatePopup = (bool) => {
    setPopup(bool)
  }
  const getPdf = (item, index) => {
    setPDFloading(index)
    API.get(DOCUMENT_PREVIEW + item.doc_field.details.issued_uuid)
      .then(response => {
        setPDFloading(null)
        setPreview(response.data.data.pdf);
      }).catch(err => {
        setPDFloading(null);
        setPreview(null)
        setLoadingText("Error while generating PDF");
      })
  }

  const DocPreview = () => {
    var loading = {
      padding: "1rem",
      height: "10vh",
      width: "-webkit-fill-available",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
    if (!preview) {
      return (<div style={loading}>
        {loadingText}
      </div>)
    }
    else {
      return (
        <embed
          key={preview}
          id="pdf-viewer"
          src={preview + "#toolbar=0"}
          type="application/pdf"
          style={{width:"700px", height:"500px"}}
        />
      )
    }
  }
  const handleDownload = async (item) => {
    try {
      setloading(true)
  
      const res = await API.get(
        DOCUMENT_PREVIEW + item.doc_field.details.issued_uuid
      )
  
      const fileUrl = res?.data?.data?.pdf
  
      // Force browser to open/download
      const link = document.createElement('a')
      link.href = fileUrl
      link.setAttribute('download', '')
      link.setAttribute('target', '_blank')
  
      document.body.appendChild(link)
      link.click()
      link.remove()
  
    } catch (err) {
      console.log(err)
    } finally {
      setloading(false)
    }
  }
  const sortList=(sort)=>{
    let direction = "asc";

       if (sortBy.key === sort && sortBy.direction === "asc") {
      direction = "desc";
  }

  const newSortBy = { key:sort, direction }
  onSortChange(newSortBy)
    
  }
  console.log(activeTab);
  
  return (
    <>
      <div className="credentials-table">
        <table>
          <tr className="credentials-header">
          <th className="credentials-th" style={{cursor:"pointer"}} onClick={()=>sortList("issued_uuid")}>
              <div className="credentials-table-text">Document ID</div>
              {sortBy.key === "issued_uuid" && (sortBy.direction === "asc" ? "↑" : "↓")}
            </th>
            <th className="credentials-th" style={{cursor:"pointer"}} onClick={()=>sortList("name")}>
              <div className="credentials-table-text">Candidate Name</div>
              {sortBy.key === "name" && (sortBy.direction === "asc" ? "↑" : "↓")}
            </th>
            <th className="credentials-th" style={{cursor:"pointer"}} onClick={()=>sortList("employee_id")}>
              <div className="credentials-table-text">Emp Id</div>
              {sortBy.key === "employee_id" && (sortBy.direction === "asc" ? "↑" : "↓")}
            </th>
            <th className="credentials-th" style={{cursor:"pointer"}} onClick={()=>sortList("document_name")}>
              <div className="credentials-table-text">Doc Name</div>
              {sortBy.key === "document_name" && (sortBy.direction === "asc" ? "↑" : "↓")}
            </th>
          {User.user_type=="Super Admin"&&  <th className="credentials-th" style={{cursor:"pointer"}} onClick={()=>sortList("employee_id")}>
              <div className="credentials-table-text">Issuer Name</div>
            </th>}
          {activeTab?.link=="DRAFT" &&  <th className="credentials-th" >
              <div className="credentials-table-text">Reason</div>
            </th>}
            <th className="credentials-th" style={{cursor:"pointer"}} onClick={()=>sortList("updated_at")}>
              <div className="credentials-table-text">Issued Date</div>
              {sortBy.key === "updated_at" && (sortBy.direction === "asc" ? "↑" : "↓")}
            </th>
            <th className="credentials-th">
              <div className="credentials-table-text">Source</div>
            </th>
            <th className="credentials-th" style={{cursor:"pointer"}} onClick={()=>sortList("issued_data_state")}>
              <div className="credentials-table-text">Status</div>
              {sortBy.key==="issued_data_state" && (sortBy.direction==="asc"?"↑":"↓")}
            </th>
            <th className="credentials-th justify-content-center">
              <div className="credentials-table-text">Actions</div>
            </th>
          </tr>
          {loading ? <>
            <tr className="credentials-tr" >
              <td className="credentials-td flex-grow-2">
                <div className="credentials-table-text"> <ShimmerLoader width='10rem' height='1.5rem' /></div>
              </td>
              <td className="credentials-td">
                <div className="credentials-table-text"><ShimmerLoader width='7rem' height='1.5rem' /></div>
              </td>
              <td className="credentials-td">
                <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
              </td>
              <td className="credentials-td">
                <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
              </td>
              <td className="credentials-td">
                <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
              </td>
              <td className="credentials-td Action-row">
                <div className="credentials-table-text"><ShimmerLoader width='7rem' height='1.5rem' /></div>
              </td>
            </tr>
            <tr className="credentials-tr" >
              <td className="credentials-td flex-grow-2">
                <div className="credentials-table-text"> <ShimmerLoader width='10rem' height='1.5rem' /></div>
              </td>
              <td className="credentials-td">
                <div className="credentials-table-text"><ShimmerLoader width='7rem' height='1.5rem' /></div>
              </td>
              <td className="credentials-td">
                <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
              </td>
              <td className="credentials-td">
                <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
              </td>
              <td className="credentials-td">
                <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
              </td>
              <td className="credentials-td Action-row">
                <div className="credentials-table-text"><ShimmerLoader width='7rem' height='1.5rem' /></div>
              </td>
            </tr>
          </> : IssuerData.length === 0 ?
            <tr className="credentials-tr">
              <td colSpan="6" className="credentials-td text-center">
                <div className="Data_List">No Record Found</div>
              </td>
            </tr>
            :
            <>
              {IssuerData.map((i, index) => {
                let state = i.doc_field.details.issued_data_state
                let issuer_id=i.doc_field.details.issuer_id
                let Actions = () => {
                  if (state == 'DRAFT') {
                    return (
                      <div title="Draft" className="eye-icon" >
                        <Link to={
                          User.user_type === "Super Admin"
                            ? `/company/2/${issuer_id}/credentials/issue-credentials`
                            : `/dashboard/credentials/issue-credentials`
                        } state={{ data: i.doc_field, isNew: true, step: 4 }}>
                          <img src="/editoutline.svg" alt="editoutline.svg" className="edit" />
                        </Link>
                      </div>
                    )
                  }
                  if (state == 'change_requested' || state == 'accepted' || state == 'rejected') {
                    return (
                      <div title="Draft" className="eye-icon" >
                        {User.user_type!=="Super Admin" &&<Link to={`/dashboard/change-request/${i.doc_field?.details?.discrepancy_ticket_id}`} state={{ data: i.doc_field, isNew: true }} className="link">
                          <Icon icon={androidOpen} size={'1rem'} />
                          View
                        </Link>}
                      </div>
                    )
                  }
                  if (state == 'PUBLISHED' || state=="ACCEPTED") {
                    return (
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div className="eye-icon" title=" View Document">
                          {pdfLoading === index ? <ShimmerLoader width='2.3rem' height='2.3rem' mt='.2rem' /> : <Link
                                                      to={User.user_type === "Super Admin"
                                                        ? `/company/2/${issuer_id}/documentDetails/${i.doc_field.details.issued_uuid}`
                                                        :`/dashboard/documentDetails/${i.doc_field.details.issued_uuid}`}
                                                      // state={{ formType: item.form_type }}
                                                      className={`link appeal_approved`}
                                                    >
                                                      <Icon icon={androidOpen} size={"1rem"} />
                                                      View
                                                    </Link>}
                        </div>
                        <div className="eye-icon" onClick={e => revokeConfirm(i)}>
                          <img title="Revoke" src="/cancel.svg" alt="cancel.svg" />
                        </div>
                        <div className="eye-icon" onClick={e => handleDownload(i)}>
                          <Icon icon={download} size={18}/>
                        </div>
                      </div>
                    )
                  }
                }
                return (
                  <tr className="credentials-tr" style={{ animationDelay: `${index * 0.025}s` }}>
                    <td className="credentials-td">
                      <div className="credentials-table-text1">{i.doc_field.details.issued_uuid}</div>
                    </td>
                    <td className="credentials-td">
                      <div className="credentials-table-text1">{i?.doc_field.details.candidate_name}</div>
                    </td>
                    <td className="credentials-td">
                      <div className="credentials-table-text1">{i?.doc_field?.issued_data?i.doc_field.issued_data?.employee_id:"NA"}</div>
                    </td>
                    <td className="credentials-td">
                      <div className="credentials-table-text1" style={{textAlign:"center"}}>{_ToNormal(i.doc_field.details.document_name)}</div>
                    </td>
                  {User.user_type=="Super Admin" &&  <td className="credentials-td">
                      <div className="credentials-table-text1" style={{textAlign:"center"}}>{i.doc_field.details.issuer_company_name}</div>
                    </td>}
                  {activeTab?.link=="DRAFT" &&  <td className="credentials-td">
                      <div className="credentials-table-text1" style={{maxWidth: "70px",
      whiteSpace: "normal",
      overflowWrap: "break-word"}}>{i?.doc_field?.details.reason_for_hold?i?.doc_field?.details.reason_for_hold:"NA"}</div>
                    </td>}
                    <td className="credentials-td">
                      <div className="credentials-table-text1">{dayjs(i.doc_field.details.updated_at).format('DD-MM-YYYY')}</div>
                    </td>
                    <td className="credentials-td">
                      <div className="credentials-table-text1">{i.doc_field.details.source}</div>
                    </td>
                    <td className="credentials-td">
                      <div className="credentials-table-text1">
                        <span className={state}>{state == 'accepted' ? 'Approved' : _ToNormal(state)}</span>
                      </div>
                    </td>
                    <td className="credentials-td Action-row">
                      <Actions />
                    </td>
                  </tr>)
              })}
            </>}
        </table>
        <ReactPortalModal title="Published Document" isOpen={preview} onClose={e => setPreview(null)}>
          <DocPreview />
        </ReactPortalModal>
      </div >
    </>
  );
};

export default Records;
